import React,{useEffect,useState}from'react';
async function api(u,o){const r=await fetch(u,{credentials:'include',headers:{'Content-Type':'application/json'},...o}),j=await r.json().catch(()=>({}));if(!r.ok)throw Error(j.error||'Request failed');return j}
const badge={pending:'bg-slate-100 text-slate-600',pending_step2:'bg-amber-100 text-amber-800',overdue_step2:'bg-red-100 text-red-800',complete:'bg-emerald-100 text-emerald-800'};
const label={pending:'Pending',pending_step2:'Awaiting Step 2',overdue_step2:'Step 2 Overdue',complete:'Complete'};
export default function AdminTBTesting(){
  const[list,setList]=useState([]),[summary,setSummary]=useState({}),[employees,setEmployees]=useState([]);
  const[f,setF]=useState({method:'two_step_tst'}),[e,setE]=useState('');
  const[step2For,setStep2For]=useState(null),[step2Form,setStep2Form]=useState({});
  const load=()=>Promise.all([api('/api/dhhs-compliance/tb-testing'),api('/api/dhhs-compliance/tb-testing/summary'),api('/api/employees')])
    .then(([a,b,c])=>{setList(a);setSummary(b);setEmployees(c)}).catch(x=>setE(x.message));
  useEffect(()=>{load()},[]);
  const add=async()=>{
    if(!f.employee_id){setE('Employee is required.');return}
    if(f.method==='two_step_tst'&&(!f.step1_date||!f.step1_result)){setE('Step 1 date and result are required.');return}
    if(f.method==='blood_test'&&(!f.blood_test_date||!f.blood_test_result)){setE('Blood test date and result are required.');return}
    try{await api('/api/dhhs-compliance/tb-testing',{method:'POST',body:JSON.stringify(f)});setF({method:'two_step_tst'});setE('');load()}
    catch(x){setE(x.message)}
  };
  const submitStep2=async(id)=>{
    try{await api(`/api/dhhs-compliance/tb-testing/${id}/step2`,{method:'POST',body:JSON.stringify(step2Form)});setStep2For(null);setStep2Form({});load()}
    catch(x){setE(x.message)}
  };
  return <div className="p-5 space-y-5">
    <header>
      <h1 className="text-3xl font-black">TB Testing Tracking</h1>
      <p className="text-slate-600">Two-step TST (retest 1-3 weeks after a negative first test) or a single TB blood test, per NH DHHS baseline testing requirements.</p>
    </header>
    {e&&<div className="bg-red-50 p-3 rounded-lg text-red-800">{e}</div>}
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      {['pending','pending_step2','overdue_step2','complete'].map(k=>
        <div key={k} className="rounded-2xl border bg-white p-4">
          <div className="text-xs uppercase text-slate-500">{label[k]}</div>
          <div className="text-2xl font-black">{summary[k]||0}</div>
        </div>
      )}
    </div>
    <section className="rounded-2xl border bg-white p-4">
      <h2 className="text-xl font-black">Add TB Test Record</h2>
      <div className="mt-3 grid gap-3 md:grid-cols-4">
        <select className="border p-3" value={f.employee_id||''} onChange={x=>setF({...f,employee_id:x.target.value})}>
          <option value="">Select Employee…</option>
          {employees.map(emp=><option key={emp.employee_id} value={emp.employee_id}>{emp.first_name} {emp.last_name}</option>)}
        </select>
        <select className="border p-3" value={f.method} onChange={x=>setF({...f,method:x.target.value})}>
          <option value="two_step_tst">Two-Step TST</option>
          <option value="blood_test">Blood Test (Quantiferon/T-Spot)</option>
        </select>
        {f.method==='two_step_tst' ? (
          <>
            <input type="date" className="border p-3" placeholder="Step 1 Date" value={f.step1_date||''} onChange={x=>setF({...f,step1_date:x.target.value})}/>
            <select className="border p-3" value={f.step1_result||''} onChange={x=>setF({...f,step1_result:x.target.value})}>
              <option value="">Step 1 Result…</option>
              <option value="negative">Negative</option>
              <option value="positive">Positive</option>
            </select>
          </>
        ) : (
          <>
            <input type="date" className="border p-3" placeholder="Test Date" value={f.blood_test_date||''} onChange={x=>setF({...f,blood_test_date:x.target.value})}/>
            <select className="border p-3" value={f.blood_test_result||''} onChange={x=>setF({...f,blood_test_result:x.target.value})}>
              <option value="">Result…</option>
              <option value="negative">Negative</option>
              <option value="positive">Positive</option>
            </select>
          </>
        )}
        <button onClick={add} className="bg-slate-900 p-3 font-bold text-white md:col-span-4 rounded-lg">Add Record</button>
      </div>
    </section>
    <section className="rounded-2xl border bg-white p-4">
      <h2 className="text-xl font-black">TB Test Records</h2>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left"><th>Employee</th><th>Method</th><th>Step 1 / Test</th><th>Step 2</th><th>Status</th><th>Action</th></tr></thead>
          <tbody>
            {list.map(x=>
              <tr key={x.id} className="border-t">
                <td className="py-3 font-bold">{x.employee_name}</td>
                <td>{x.method==='two_step_tst'?'Two-Step TST':'Blood Test'}</td>
                <td>{x.method==='two_step_tst' ? `${x.step1_date} — ${x.step1_result}` : `${x.blood_test_date} — ${x.blood_test_result}`}</td>
                <td>{x.step2_date ? `${x.step2_date} — ${x.step2_result}` : '—'}</td>
                <td><span className={`px-2 py-1 rounded-full text-xs font-bold ${badge[x.status]}`}>{label[x.status]}</span></td>
                <td>
                  {(x.status==='pending_step2'||x.status==='overdue_step2') && (
                    step2For===x.id ? (
                      <div className="flex gap-2 items-center">
                        <input type="date" className="border p-1 text-xs" onChange={ev=>setStep2Form({...step2Form,step2_date:ev.target.value})}/>
                        <select className="border p-1 text-xs" onChange={ev=>setStep2Form({...step2Form,step2_result:ev.target.value})}>
                          <option value="">Result…</option>
                          <option value="negative">Negative</option>
                          <option value="positive">Positive</option>
                        </select>
                        <button className="text-emerald-700 font-bold" onClick={()=>submitStep2(x.id)}>Save</button>
                        <button className="text-slate-500" onClick={()=>setStep2For(null)}>Cancel</button>
                      </div>
                    ) : (
                      <button className="text-blue-700 font-bold" onClick={()=>setStep2For(x.id)}>Record Step 2</button>
                    )
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  </div>;
}
